import { ShopWebhookDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { Button } from "@babackapp/ui/components/button";
import { Link2Icon } from "@radix-ui/react-icons";
import UpdateWebhookDialog from "./update-webhook-dialog.tsx";

type WebhooksListItemProps = {
  webhook: ShopWebhookDto;
};

export default function WebhooksListItem({ webhook }: WebhooksListItemProps) {
  const t = useTranslation();

  return (
    <UpdateWebhookDialog webhook={webhook}>
      <Button
        className="h-auto w-full justify-start text-left pr-6 cursor-pointer"
        variant="ghost"
        asChild
      >
        <div className="flex items-center justify-start gap-4">
          <Link2Icon className="w-6 h-6 text-muted-foreground" />
          <div className="flex flex-col gap-1 justify-start min-w-0">
            <span className="font-medium text-gray-900 text-sm truncate">
              <span className="text-muted-foreground/80 font-medium text-xs">
                /POST
              </span>{" "}
              {webhook.url}
            </span>
            <span className="text-muted-foreground text-xs">
              {webhook.subscriptions.length}{" "}
              {/**
               * TODO: Handle pluralization
               */}
              {t("settings.integrations.webhooks.events")}
            </span>
          </div>
        </div>
      </Button>
    </UpdateWebhookDialog>
  );
}
